import React, { useState, useEffect } from "react";

const Recepients = (props) => {
  const [date, setNewDate] = useState();

  useEffect(() => {
    const date = new Date(props.executedDate);

    const executionDate = date.toString();

    setNewDate(executionDate);
  }, []);

  return (
    <div className="pt-4">
      <div className=" p-4 rounded-md border border-gray-400 hover:shadow-md cursor-pointer ">
        <div className=" grid grid-cols-3 md:grid-cols-4 gap-10 items-center">
          <p className="   text-sm    text-gray-400 overflow-hidden">
            {props.Sender}
          </p>

          <p className="text-sm text-gray-400 ml-4"> {props.Amount} </p>

          <p className="text-sm text-gray-400"> {date}</p>
          <div className="flex justify-">
            <center>
              <button className=" border rounded-full  h-10 w-24 bg-slate-600 hover:bg-slate-400  text-sm text-white ml-auto ">
                Received
              </button>
            </center>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Recepients;
